import { Component, Input, ComponentFactoryResolver, ViewContainerRef, ViewChild, AfterViewInit, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { Events, NavParams, ModalController } from 'ionic-angular';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { StoreWrapProvider } from '../../providers/store-wrap/store-wrap';
import { defaultForm } from '../../components/form/defaultForm/defaultForm.component';
import { MyGridApplicationComponent } from '../../components/my-grid-application/my-grid-application';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service';
@Component({
  selector: 'form-grid',
  templateUrl: 'form-grid.html'
})
export class FormGridComponent implements AfterViewInit {
  @ViewChild('formComponentHolder', { read: ViewContainerRef, static: false }) formComponentHolder: ViewContainerRef;
  @ViewChild('gridComponentHolder', { read: ViewContainerRef, static: false }) gridComponentHolder: ViewContainerRef;
  @Input() params: any = '';
  @Input() accessType: any = '';
  @Input() templateName: any = '';
  @Input() componentName: any = '';
  @Input() dataAccessType: any = '';
  @Input() screenProps: any = '';
  @Input() components: any;



  isChildForm: any;
  field: any;
  sourceField: any;
  templateId: any;
  sourceScreen: any;
  parentForm: any;
  screenType: any = '';
  showGrid: any = true;
  componentRef: any;
  showGridApplication: boolean = false;
  userId: any;
  form: any;
  gridRowData: any = [];
  rowDataStatus: any = false;
  broadcastSubs: any;
  constructor(public navParams: NavParams, public modal: ModalController, public events: Events, public communicationServ: CommunicationServiceProvider, public configApiService: ConfigApiServiceProvider, private storeWrap: StoreWrapProvider, private cdr: ChangeDetectorRef, public driveService: DriveServiceProvider, private componentFactoryResolver: ComponentFactoryResolver) {


    /* * * * * * * *        
    *Add new record 
    * * *  * * * * */

    this.events.subscribe('openFileUpload', (status) => {
      if (status == true) {
        this.showGrid = false
      } else {
        this.showGrid = true
        this.loadGridComponent(this.componentName, this.params, this.templateName)
      }
    });



    this.events.subscribe('getAppComponents', (flag, component) => {
      if (flag) {
        this.components = component;
      }
    });

    this.initDriveEvents()
  }

  initDriveEvents() {
    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "form-grid") {
          if (data.event === 'tabTriggerDataToGridApplication') {
            this.rowDataStatus = data['rowDataStatus'];
            this.gridRowData = data['gridRowData'];
            this.showGridApplication = data.status;
            this.screenProps = data.screenProps;
            this.templateName = data.screenProps.id;
            this.componentName = data.componentName;
            this.accessType = data.accessType;
            this.showGrid = true;
            this.params = data.parentScreenParam;
            this.dataAccessType = data.dataAccessType;
            if (this.screenProps.componentName != "SUMMARY") {
              setTimeout(() => {
                this.clearFormLayoutData();
              }, 100);

            }
            if (!this.components) {
              this.components = data.components;
            }
            this.ngAfterViewInit();
          } else if (data.event === 'loadComponentCurrentData') {
            let templates = data['templates'];
            let params = data['params']
            this.params = params;
            let parentScreenParam = {};
            parentScreenParam[this.screenProps['sourceKey']] = this.params[this.screenProps['sourceKey']];

            this.driveService.fetchScreenProperties(parentScreenParam, this.screenProps.id, (screenProps, gridRowData = null) => {
              this.screenProps = screenProps;
              if (screenProps.componentName == "SUMMARY") {
                this.loadPopupComponent(this.componentName, this.params, this.templateName);
              } else {
                this.loadDefaultComponent(this.componentName, this.params, this.templateName);
              }

            });
          } else if (data.event === 'deleteRowRecord') {
            let status = data['status'];
            if (status) {
              if (this.driveService.objCurrentFolder.template.findIndex(element => element.id == this.screenProps.id) > 0) {
                let sourceKey = this.storeWrap.storeTemplates[this.driveService.objCurrentFolder.template[0].id].sourceKey
                this.params = { [sourceKey]: this.params[sourceKey] }
                if (this.screenProps.componentName != "SUMMARY") {
                  this.clearFormLayoutData();
                }
              }
            }
          } else if (data.event === 'addNewRecordDefaultForm') {
            let status = data['status'];
            if (status) {
              if (this.driveService.objCurrentFolder.template.findIndex(element => element.id == this.screenProps.id) > 0) {
                let sourceKey = this.storeWrap.storeTemplates[this.driveService.objCurrentFolder.template[0].id].sourceKey
                this.params = { [sourceKey]: this.params[sourceKey] }
                this.clearFormLayoutData();
              }
            }
          }
        } else if (data.src === 'defaultProps') {
          if (data.event === 'passParentScreenParamOnNew') {
            if (data.params) {
              this.params = data.params;
            }
          }
        }
      })
  }
  deepClone<T>(obj: T): T {
    return JSON.parse(JSON.stringify(obj)) as T;
  }

  ngOnInit() {
    /* * * * * * * * * *
     * Get app componets
     * * * * * * * * * */
    this.driveService.broadcastInfo({ src: 'defaultProps', event: 'pullAppComponents', status: true });
    this.showGridApplication = true;
    this.showGrid = true;

    /* * * * * * * * * *
  * child form navparams
  * * * * * * * * * */
    if (this.navParams.get('chilFormParams')) {
      let chilFormParams = this.navParams.get('chilFormParams');
      this.field = chilFormParams['field'];
      this.screenProps = chilFormParams['screenProps'];
      this.screenType = chilFormParams['screenType'];
      this.parentForm = chilFormParams['parentForm'];
      this.sourceField = chilFormParams['sourceField'];
      this.sourceScreen = chilFormParams['sourceScreen'];
      this.templateId = chilFormParams['templateId'];
      this.params = chilFormParams['params'];
    }
  }

  ngOnDestroy() {
    this.driveService.candidateFlag = false;
  }

  clearFormLayoutData() {
    let checkDataAccessType
    checkDataAccessType = (this.dataAccessType === "newdata" ? "header" : null);
    let formLayout = this.driveService.clearFormLayoutData(this.screenProps['formLayout'], this.params, checkDataAccessType);
    this.screenProps['formLayout'] = formLayout;
    if (this.screenProps.componentName == "SUMMARY") {
      this.loadPopupComponent(this.componentName, this.params, this.templateName);
    } else {
      this.loadDefaultComponent(this.componentName, this.params, this.templateName);
    }
    // this.loadDefaultComponent(this.componentName, this.params, this.templateName);
  }

  ngAfterViewInit() {
    // setTimeout(() => {
    if (this.screenProps) {
      if (this.screenProps.componentName !== "SUMMARY" && this.screenProps.componentName !== "FormGridComponent" && this.screenProps.componentName != 'SEARCHGRID') {
        this.clearFormLayoutData();
      }
      this.loadGridComponent(this.componentName, this.params, this.templateName);
    }
    // }, 1000);
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  /* * * * * * *
  * Default Component
  * * * * * * */
  loadDefaultComponent(template, param, templateName) {
    let component = template;
    if (this.screenProps.componentName != "SUMMARY") {
      if (!component) {
        if (this.formComponentHolder) {
          this.formComponentHolder.clear();
        }
        let componentFactory = this.componentFactoryResolver.resolveComponentFactory(defaultForm);
        if (!componentFactory) {
          componentFactory = this.componentFactoryResolver.resolveComponentFactory(defaultForm);
        }
        this.componentRef = this.formComponentHolder.createComponent(componentFactory);
        this.componentRef.instance.screenProps = this.screenProps;
      } else {
        if (this.formComponentHolder) {
          this.formComponentHolder.clear();
        }
        let componentFactory = this.componentFactoryResolver.resolveComponentFactory(component['comp']);
        if (!componentFactory) {
          componentFactory = this.componentFactoryResolver.resolveComponentFactory(component['comp']);
        }
        this.componentRef = this.formComponentHolder.createComponent(componentFactory);
      }
      this.componentRef.instance.params = param;
      this.componentRef.instance.templateName = templateName;
      this.componentRef.instance.accessType = this.accessType;
      this.componentRef.instance.screenProps = this.screenProps;
      this.componentRef.instance.components = this.components;
      if(this.driveService.containerComp == 'Default'){
        this.broadcastSubs.unsubscribe();
      }
    }
    setTimeout(() => {
      this.events.publish('enableDefaultFromNewButton', true);
    }, 100);
  }

  /*****
   * POPUP COMPONENT
   * **** */
  loadPopupComponent(template, param, templateName) {
    let field = {};
    field['FieldDataType'] = 'defaultFrom';
    let chilFormParams = {
      'field': field,
      'params': param,
      'isChildForm': true,
      'screenType': 'popup',
      'parentForm': this.form,
      'sourceField': this.sourceField,
      'sourceScreen': "",
      'screenProps': this.screenProps,
      'screenName': this.screenProps.templateName,
    }
    let component = null;
    // if (objComponent) {
    //   component = objComponent;
    // } else {
    component = this.getComponent(this.screenProps.id + '-customForm');
    if (!component) {
      component = null;
    }
    // }


    if (!component) {
      component = this.components[0];
      var modalPage = this.modal.create(component['comp'], { 'chilFormParams': chilFormParams }, { cssClass: "modal-custom-field-type", showBackdrop: true, enableBackdropDismiss: false });
      modalPage.present();
    } else {
      var modalPage = this.modal.create(component['comp'], { 'chilFormParams': chilFormParams }, { cssClass: "modal-custom-field-type", showBackdrop: true, enableBackdropDismiss: false });
      modalPage.present();
    }
    setTimeout(() => {
      this.events.publish('enableDefaultFromNewButton', true);
    }, 100);
  }


  /* * * * * * *
  * My Grid Component
  * * * * * * */
  loadGridComponent(template, param, templateID) {
    if (this.gridComponentHolder != undefined) {
      this.gridComponentHolder.clear();
    }
    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(MyGridApplicationComponent);
    if (!componentFactory) {
      componentFactory = this.componentFactoryResolver.resolveComponentFactory(MyGridApplicationComponent);
    }

    setTimeout(() => {
      this.componentRef = this.gridComponentHolder.createComponent(componentFactory);                        //<<<---using ()=> syntax
      this.componentRef.instance.customHeight = true;
      this.componentRef.instance.gridRowData = this.gridRowData;
      this.componentRef.instance.rowDataStatus = this.rowDataStatus;
      this.componentRef.instance.templateID = templateID;
      this.componentRef.instance.params = param;
      this.componentRef.instance.screenProps = this.screenProps;
    }, 500);
  }


  getComponent(name) {
    let components = this.components;
    for (let i = 0; i < components.length; i++) {
      let item = components[i];
      if (item.compName === name) {

        return item['comp'];
      }
    };
    return null;
  }


}



// WEBPACK FOOTER //
// ./src/components/form-grid/form-grid.ts